import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-common-popup',
  templateUrl: './common-popup.component.html',
  styleUrls: ['./common-popup.component.scss']
})
export class CommonPopupComponent {
  @Input() sendToMailOrWhatsapp;
  @Input() UpdateStatus;
  @Input() isDeleteConfirm;
  @Input() isSaveConfirm;
constructor(public activeModal:NgbActiveModal){}

}
